module.exports = __webpack_public_path__ + "static/media/0022.2e1b1d90.png";